import { render, staticRenderFns } from "./OpearatorsUsers.vue?vue&type=template&id=3020e460&scoped=true"
import script from "./OpearatorsUsers.vue?vue&type=script&lang=js"
export * from "./OpearatorsUsers.vue?vue&type=script&lang=js"
import style0 from "./OpearatorsUsers.vue?vue&type=style&index=0&id=3020e460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3020e460",
  null
  
)

export default component.exports